import { Pagination } from 'react-admin';

const RecordPagination = props => <Pagination rowsPerPageOptions={[10, 15, 25, 50, 100]} {...props} />;

export default RecordPagination